import React from 'react';
import { Text } from '@chakra-ui/react';

export const Title = React.memo(({ children }) => {
  return (
    <Text
      color="gray.600"
      fontSize={{ base: 18, sm: 24, lg: 28 }}
      fontWeight="bold"
      mb={{ base: 2, md: 4 }}
    >
      {children}
    </Text>
  );
});
